
export default {
    namespaced: true,
    state: {
        esMoroso: false
    },
    mutations: {
        SET_ESMOROSO(state, valor){
            state.esMoroso = valor;
        }
    },
    actions: {
        setEsMoroso({commit}, valor){
            commit('SET_ESMOROSO', valor);
        }
    }
}